// import { call, select } from 'redux-saga/effects';
import { getConvertingPremiumGalleryPrice, getCurrentFolderId, getGallectionById, getGrusername, getIsConvertingPremiumGallery } from '../selectors';
import { call, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { getGallectionType } from '../helpers';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
function* mediaManagerClosedHandler() {
    const isConvertingToPremiumGallery = yield select(getIsConvertingPremiumGallery);
    // bail if user did not toggle to convert gallery
    if (!isConvertingToPremiumGallery) {
        return;
    }
    const currentFolderId = yield select(getCurrentFolderId);
    const gallection = yield select(getGallectionById, currentFolderId);
    const username = yield select(getGrusername);
    const pointsPrice = yield select(getConvertingPremiumGalleryPrice);
    if (!gallection) {
        return;
    }
    var _getGallectionType, _gallection_description;
    const params = {
        username,
        type: (_getGallectionType = getGallectionType(gallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'gallery',
        folderid: gallection.folderId,
        name: gallection.name,
        description: (_gallection_description = gallection.description) !== null && _gallection_description !== void 0 ? _gallection_description : undefined,
        premium_type: 'paid',
        cover_deviationid: gallection.type === 'stash' ? undefined : get(gallection, 'thumb.deviationId'),
        points_price: pointsPrice
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'gallection/folders/update',
        data: params
    });
    // new gallery converted to premium, reload page
    if (result) {
        window.location.reload();
    }
}
export default mediaManagerClosedHandler;

//# sourceMappingURL=mediaManagerClosed.js.map